import styles from "./register.module.scss";

export const RegisterSuccess = () => {
  return (
    <div className={styles.success}>
      Регистрация прошла успешно. Проверьте почту
    </div>
  );
};
